/** Admin panel tab ids — must match sql auth_has_admin_panel_tab + Dashboard nav item ids */

export const ADMIN_PANEL_TAB_DEFS = [
  { id: 'dashboard', label: 'Dashboard', group: 'Kafe yönetimi' },
  { id: 'users', label: 'Kullanıcılar', group: 'Kafe yönetimi' },
  { id: 'stamp-cards', label: 'Damga kartları', group: 'Kafe yönetimi' },
  { id: 'ekip', label: 'Ekip', group: 'Kafe yönetimi' },
  { id: 'checklist', label: 'Günlük checklist', group: 'Kafe yönetimi' },
  { id: 'shifts', label: 'Vardiya planı', group: 'Kafe yönetimi' },
  { id: 'shops', label: 'Mağazalar', group: 'Uygulama yönetimi' },
  { id: 'ads', label: 'Reklamlar', group: 'Uygulama yönetimi' },
  { id: 'media', label: 'Medya', group: 'Uygulama yönetimi' },
  { id: 'app-calendar-events', label: 'Uygulama takvimi', group: 'Uygulama yönetimi' },
  { id: 'qr-codes', label: 'QR Codes', group: 'Uygulama yönetimi' },
  { id: 'orders', label: 'Siparişler', group: 'Uygulama yönetimi' },
  { id: 'simpra', label: 'Simpra', group: 'Uygulama yönetimi' },
];

export const ADMIN_PANEL_TAB_IDS = new Set(ADMIN_PANEL_TAB_DEFS.map((t) => t.id));

const SECTION_TO_MENU = {
  ekip: 'ekip',
  shops: 'shops',
  ads: 'ads',
  media: 'media',
  settings: 'settings',
  'app-calendar': 'app-calendar-events',
  users: 'users',
  'stamp-cards': 'stamp-cards',
  checklist: 'checklist',
  shifts: 'shifts',
  'qr-codes': 'qr-codes',
  orders: 'orders',
  simpra: 'simpra',
};

export function menuIdFromSection(section) {
  if (!section) return 'dashboard';
  return SECTION_TO_MENU[section] || section;
}

export function sectionFromMenuId(menuId) {
  if (menuId === 'dashboard') return null;
  if (menuId === 'app-calendar-events') return 'app-calendar';
  return menuId;
}

export function canAccessPanelTab(access, tabId) {
  if (!access) return false;
  if (access.isOwner) return true;
  return Array.isArray(access.tabs) && access.tabs.includes(tabId);
}

export function filterNavGroups(navGroups, access) {
  if (access == null) return [];
  if (access.isOwner) return navGroups;
  return navGroups
    .map((group) => ({
      ...group,
      items: group.items.filter(
        (item) =>
          item.alwaysShow
          || (!item.ownerOnly && canAccessPanelTab(access, item.id)),
      ),
    }))
    .filter((group) => group.items.length > 0);
}

export function normalizePanelTabIds(tabs) {
  if (!Array.isArray(tabs)) return [];
  return [...new Set(tabs.filter((id) => ADMIN_PANEL_TAB_IDS.has(id)))];
}

export function labelForPanelTabs(tabIds) {
  const ids = normalizePanelTabIds(tabIds);
  if (!ids.length) return '—';
  return ids
    .map((id) => ADMIN_PANEL_TAB_DEFS.find((t) => t.id === id)?.label || id)
    .join(', ');
}
